import { render, staticRenderFns } from "./areas.vue?vue&type=template&id=f3ae42bc&"
import script from "./areas.vue?vue&type=script&lang=js&"
export * from "./areas.vue?vue&type=script&lang=js&"
import style0 from "./areas.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "areas.vue"
export default component.exports